import { cn } from '@/lib/utils'
import { Icon } from '@/ui/components'
import React from 'react'

export interface RatingStarsProps extends React.HTMLAttributes<HTMLDivElement> {
  stars?:
    | 0
    | 0.5
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | 1.5
    | 2.5
    | 3.5
    | 4.5
    | '1.5'
    | '2.5'
    | '3.5'
    | '4.5'
    | (() => number)
  isSuperior?: boolean // TODO: remove this prop
  isTypo3?: boolean // TODO: remove this prop
}

function getStars(item: string) {
  const match = item.match(/-?\d+/)
  const fixed = match ? Math.round(parseFloat(item) * 10) : 0
  const number = fixed / 10
  return number ? number : 0
}

const RatingStars: React.FC<RatingStarsProps> = ({
  stars,
  isTypo3,
  isSuperior = false, // TODO: remove this prop
  className, // TODO: remove this prop
  ...props
}) => {
  // Determine the number of stars
  const numberOfStars =
    typeof stars === 'function'
      ? stars()
      : typeof stars === 'string'
        ? getStars(stars)
        : stars

  if (!numberOfStars) {
    return null
  }

  const superior = isSuperior || numberOfStars > 5
  const starsNumber =
    Math.trunc(numberOfStars) > 5 ? 5 : Math.trunc(numberOfStars)
  const numberOfStarsOutline = 5 - starsNumber - (numberOfStars % 1 > 0 ? 1 : 0)

  return (
    <div {...props} className={cn('flex', className)}>
      {Array.from({ length: starsNumber as number }, (_, index) => (
        <Icon
          icon="material-symbols:star"
          className="h-6 w-6"
          key={index?.toString()}
        />
      ))}
      {numberOfStars % 1 > 0 && (
        <Icon icon="material-symbols:star-half" className="h-6 w-6" />
      )}
      {numberOfStars < 5 &&
        Array.from({ length: numberOfStarsOutline as number }, (_, index) => (
          <Icon
            key={index?.toString()}
            icon="material-symbols:star-outline"
            className="h-6 w-6"
          />
        ))}
      {superior && <Icon icon="mdi:crown" className="h-6 w-6" />}
    </div>
  )
}

export default RatingStars
